<template>
  <page-status class="eproposal-index" :loading="loading"> </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import imgError from '@/assets/img-status-error.png';
import * as services from '@/services';

export default {
  components: {
    PageStatus,
  },

  data() {
    return {
      loading: true,
      imgError,
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    const {
      businessNo,
      code,
      newEnergyFlag,
      lawfulFlag,
      isIdentityCollect,
    } = this.$route.query;
    // 北京身份信息采集
    // if (isIdentityCollect && isIdentityCollect === '0') {
    //   this.$router.push({
    //     path: '/identity-collect',
    //     query: this.$route.query,
    //   });
    //   return;
    // }

    // 合规经营书
    if (lawfulFlag === '1') {
      this.$router.push({ path: '/new-lawful', query: this.$route.query });
      return;
    }
    //北京新能源跳转
    if (newEnergyFlag === '1') {
      this.$router.push({ path: '/new-energy', query: this.$route.query });
      return;
    }
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { businessNo, code } = this.$route.query;
      services
        .eproposalShift(businessNo)
        .then(res => {
          const { content } = res;
          if (content) {
            const newUrl = code ? `${content}&code=${code}` : content;
            window.location.replace(newUrl);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less">
.eproposal-index {
  height: 100%;

  .page-result {
    background-color: #ffffff;

    .btn {
      width: 160px;
      height: 44px;
      line-height: 44px;
      border-radius: 4px;
      border: solid 1px #1665d8;
      text-align: center;
      color: #1665d8;
      font-size: 18px;
      margin: 0 auto;
    }
  }
}
</style>
